import { getIconByName } from '@algbra/ui/icons'
import { useRef, useState } from 'react'
import styles from './SubbannerVideo.module.scss'
import { SubbannerVideoFullScreen } from './SubbannerVideoFullscreen'
import Button from '@algbra/ui/components/Button/Button'
import classNames from 'classnames'

export type SubbannerVideoProps = {
  video_url?: string
  title?: string
  devByAlgbraLabs?: boolean
  youtube_code?: string
  isPlaylist?: boolean
}
export function SubbannerVideo({
  video_url,
  title,
  devByAlgbraLabs,
  youtube_code,
  isPlaylist,
}: SubbannerVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [isFullscreen, setFullscreen] = useState(false)
  const onToggleVideo = () => {
    setFullscreen(!isFullscreen)
  }

  return (
    <>
      <div className={styles.videoContainer}>
        <div className={styles.mask} />
        <video
          ref={videoRef}
          src={video_url}
          className={styles.video}
          playsInline={true}
          autoPlay={true}
          loop={true}
          muted={true}
        />
        {title && (
          <div className={styles.title}>
            <div dangerouslySetInnerHTML={{ __html: title }}></div>
            <Button
              theme="light"
              size="small"
              icon={getIconByName('arrow-play')}
              className={classNames(styles.videoPlay, styles.reversedButton)}
              onClick={onToggleVideo}
            >
              Watch
            </Button>
            {devByAlgbraLabs && (
              <div className={styles.devBy}>
                developed by
                <img src="/images/labs-logo.svg" alt="Algbra Labs" />
                <span>labs</span>
              </div>
            )}
          </div>
        )}
      </div>
      {isFullscreen && (
        <SubbannerVideoFullScreen
          onToggleVideo={onToggleVideo}
          youtube_code={youtube_code}
          isPlaylist={isPlaylist}
        />
      )}
    </>
  )
}
